import {reactive} from "@vue/reactivity"

const globalState = reactive({
    sidebarVisible: false,
    dataSaved: false
})

export default globalState
